"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createDynamicObjectMemberProxy_1 = require("./createDynamicObjectMemberProxy");
var deepFreeze_1 = require("./deepFreeze");
/**
 * Performs final cleanup after a store update by deep freezes any patched nodes within
 * the store's value, while also reflecting any changes made to map proxies if present.
 * Runs only once all batched actions for a store are complete.
 */
var completeStoreUpdate = function (store, emitInternalUpdate) {
    if (emitInternalUpdate === void 0) { emitInternalUpdate = true; }
    if (emitInternalUpdate)
        store.internal$.next(store.value);
    deepFreeze_1.default(store.value, store.patches, store.proxies, createDynamicObjectMemberProxy_1.default.bind(null, store));
    store.patches = {};
    store.isActioning = false;
};
exports.default = completeStoreUpdate;
//# sourceMappingURL=completeStoreUpdate.js.map